import React from 'react';
import { UserCheck } from 'lucide-react';
import Pill, { difficultyLabel, lessonStatusLabel, lessonStatusTone } from '../../parentPortal/components/Pill';
import { formatDateFull, humanHours, masteryLabel, masteryTone } from '../utils/format';

export default function PortfolioCourseRow({ course }) {
  const started = formatDateFull(course.startedAt);
  const completed = formatDateFull(course.completedAt);
  const dateRange =
    course.status === 'COMPLETED'
      ? completed
        ? `${started ? started + ' – ' : ''}${completed}`
        : ''
      : started
      ? `Started ${started}`
      : '';
  // Hide time spent and mastery until backend has real data sources — they'd
  // otherwise always render as 0m / "—". When either lands, this renders
  // automatically. The mastery column also drops entirely when null so the
  // row doesn't leave dead space on the right.
  const showMinutes = course.minutesLearned > 0;
  const showMastery = course.masteryPercent != null;
  return (
    <div
      style={{
        background: 'var(--card-bg)',
        border: '1px solid var(--card-border)',
        borderRadius: 'var(--radius-panel)',
        padding: 'var(--space-3) var(--space-4)',
        display: 'grid',
        gridTemplateColumns: showMastery ? 'minmax(0, 1fr) auto' : 'minmax(0, 1fr)',
        gap: 'var(--space-3)',
        alignItems: 'center',
      }}
    >
      <div style={{ minWidth: 0 }}>
        <div
          style={{
            display: 'flex',
            gap: 'var(--space-2)',
            alignItems: 'center',
            flexWrap: 'wrap',
            marginBottom: 'var(--space-2)',
          }}
        >
          <span
            style={{
              fontSize: 'var(--text-panel-size)',
              fontWeight: 700,
              color: 'var(--text-primary)',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {course.title}
          </span>
          <Pill>{difficultyLabel(course.difficulty)}</Pill>
          <Pill tone={lessonStatusTone(course.status)}>
            {lessonStatusLabel(course.status)}
          </Pill>
          {course.assignedByParent && (
            <Pill tone="accent">
              <UserCheck size={11} strokeWidth={2.5} />
              Parent-assigned
            </Pill>
          )}
        </div>
        <div
          style={{
            display: 'flex',
            gap: 'var(--space-3)',
            fontSize: 'var(--text-numeric-size)',
            color: 'var(--text-tertiary)',
            flexWrap: 'wrap',
          }}
        >
          {dateRange && <span>{dateRange}</span>}
          <span>
            {course.completedLessonCount} / {course.lessonCount} lessons
          </span>
          {showMinutes && <span>{humanHours(course.minutesLearned)}</span>}
        </div>
      </div>

      {showMastery && (
        <div style={{ textAlign: 'right', minWidth: 96 }}>
          <div
            style={{
              fontSize: 'var(--text-section-size)',
              fontWeight: 800,
              color: 'var(--text-primary)',
              lineHeight: 1,
            }}
          >
            {course.masteryPercent}%
          </div>
          <div style={{ marginTop: 'var(--space-2)' }}>
            <Pill tone={masteryTone(course.masteryPercent)}>
              {masteryLabel(course.masteryPercent)}
            </Pill>
          </div>
        </div>
      )}
    </div>
  );
}
